import Vue from 'vue'
import LoadingMask from '@/components/LoadingMask.vue'

// 全局组件注册
Vue.component('LoadingMask', LoadingMask)

// 后续可以在这里添加更多全局组件 